import React from "react";

function ContactUs() {
  return (
    <section className="hero" style={{ 'align-items': 'flex-start', }}>
      <div className="container">
        <h1>Bize Ulaşın</h1>
        <p>
          Crypto Trail Officer ekibi olarak her zaman iletişime açık ve ulaşılabilir olmaya önem veriyoruz. 
          Ürünlerimiz hakkında sorularınız, teknik destek talepleriniz, iş birliği ve ortaklık fırsatları ya da 
          geri bildirimleriniz için bizimle doğrudan iletişime geçebilirsiniz.
        </p>
        <p>
          Aşağıdaki e-posta adresi üzerinden bize ulaşabilir, düşüncelerinizi veya taleplerinizi ekibimizle paylaşabilirsiniz. 
          Size en kısa sürede dönüş yapmaktan memnuniyet duyacağız.
        </p>
        <p>
          <a class="btn btn-outline" href="mailto:info@cryptotrailofficer.ai">info@cryptotrailofficer.ai</a>
        </p>
      </div>
    </section>
  );
}

export default ContactUs;
